import { Transition } from "@headlessui/react";

export default function DropdownMenu({isOpen, content, classname = "flex py-3 mt-2 bg-white rounded-md shadow-lg"}) {

  return (
    <div>
      <Transition
        show={isOpen}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 transform scale-95"
        enterTo="opacity-100 transform scale-100"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 transform scale-100"
        leaveTo="opacity-0 transform scale-95"
      >
        <div className={classname}>
          {content}
        </div>
      </Transition>
    </div>
  );
}
